import { render, staticRenderFns } from "./sysDictionary.vue?vue&type=template&id=c5b1a124&"
import script from "./sysDictionary.vue?vue&type=script&lang=js&"
export * from "./sysDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b1a124')) {
      api.createRecord('c5b1a124', component.options)
    } else {
      api.reload('c5b1a124', component.options)
    }
    module.hot.accept("./sysDictionary.vue?vue&type=template&id=c5b1a124&", function () {
      api.rerender('c5b1a124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/systemTools/dictionary/sysDictionary.vue"
export default component.exports